import React, { useState } from 'react';

export default props => {
    const { sections, HeaderComponent, ItemsComponent, ItemWrapComponent = React.Fragment, activeSection: activeSectionRedux, setActiveSection, internalState } = props;

    const [activeSectionState, setActiveSectionState] = useState(0);

    const handleClick = idx => {
        if (idx === activeSection) {
            idx = -1;
        }

        if (internalState) {
            return setActiveSectionState(idx);
        }

        setActiveSection(idx);
    }

    const activeSection = internalState ? activeSectionState : activeSectionRedux;

    return sections.map((section, i) => (
        <ItemWrapComponent active={i === activeSection} key={`section-${i}`}>
            <HeaderComponent active={i === activeSection} {...section} onClick={() => handleClick(i)} />
            {i === activeSection && <ItemsComponent {...section} />}
        </ItemWrapComponent>
    ));
}